import React from "react";
import UnitRelationForm from "./UnitRelationForm";
import UnitRelationList from "./UnitRelationList";

const UnitRelation = () => {
  return (
    <>
      <UnitRelationForm />
      <UnitRelationList />
    </>
  );
};

export default UnitRelation;
